<template>
  <v-card v-if="testPlan.status" class="och-testPlanCard__border--bottom">
    <v-card-text>
      <v-row wrap cols="12" no-gutters>
        <v-col sm="12" md="6" v-if="testPlan.status">
          <span class="font-weight-bold grey--text text--darken-3">Testing Status: </span>
          <span
            >{{ testPlan.status }}
            <span v-if="testPlan.implementationStatus"> - {{ testPlan.implementationStatus }} </span>
          </span>
        </v-col>
        <v-col sm="12" md="6">
          <span class="font-weight-bold grey--text text--darken-3">Assigned To: </span>
          <span>{{ testPlan.assignedToDisplayName || testPlan.assignedTo || 'Unassigned' }}</span>
        </v-col>
      </v-row>
      <v-row wrap cols="12" no-gutters>
        <v-col sm="12" md="6" v-if="testPlan.reportedDate">
          <span class="font-weight-bold grey--text text--darken-3">Reported Date: </span>
          <span>{{ testPlan.reportedDate }}</span>
        </v-col>
        <v-col sm="12" md="6" v-if="testPlan.reportedComments">
          <span class="font-weight-bold grey--text text--darken-3">Reported Comments: </span>
          <span>{{ testPlan.reportedComments }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "testPlanStatus",
  components: {},
  computed: {
    releaseNote() {
      return this.$store.state.releaseNote.releaseNoteRecord;
    },
    testPlan() {
      return this.$store.state.releaseNote.testPlan;
    },
    serviceArea() {
      return this.$store.state.session.serviceArea;
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("releaseNote/getReleaseNoteRecord", this.releaseNoteId),
      this.$store.dispatch("releaseNote/getTestPlan", {
        releaseNoteId: this.releaseNoteId,
        serviceArea: this.serviceArea,
      }),
    ]);
  },
  props: ["releaseNoteId"],
};
</script>
